import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import QueueTable from "./QueueTable";
import { MentorQueuesData } from "../../types";
import { loadQueuedMentors, beginSession } from "../../redux/actions/guideStreamActions";
import Loading from "../../../Shared/loading";
import { SessionStub } from "../../../Shared/GeneratedTypes";
import useInterval from "../../../Shared/useInterval";

const mapState = ({ queuedMentors, localizations, apiCallsInProgress }: MentorQueuesData) => ({
    queuedMentors,
    localizations: localizations!,
    apiCallsInProgress,
});

const mapDispatch = {
    loadQueuedMentors,
    beginSession,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};

function QueuePage({ queuedMentors, loadQueuedMentors, localizations, beginSession, apiCallsInProgress }: PropTypes) {
    // const { queuedMentors, loadQueuedMentors } = props;
    useEffect(() => {
        // if (!queuedMentors || queuedMentors.length === 0) {
        loadQueuedMentors();
        // }
    }, []);

    const [secondsUntilRefresh, updateSecondsUntilRefresh] = useState(30);

    useInterval(() => {
        if (secondsUntilRefresh === 0) {
            loadQueuedMentors();
            updateSecondsUntilRefresh(30);
        } else {
            updateSecondsUntilRefresh(secondsUntilRefresh - 1);
        }
    }, 1000);

    const refreshNow = () => {
        loadQueuedMentors();
        updateSecondsUntilRefresh(30);
    };
    function selectMentor(session: SessionStub) {
        beginSession(session.customerId, session.id!);
    }

    return (
        <>
            {apiCallsInProgress > 0 ? (
                <>
                    <Loading message={localizations.loadingMentors} />
                </>
            ) : (
                <QueueTable
                    queuedMentors={queuedMentors}
                    refreshNow={refreshNow}
                    refreshTimer={secondsUntilRefresh}
                    localizations={localizations}
                    setActive={selectMentor}
                />
            )}
        </>
    );
}

export default connector(QueuePage);
